/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



/* =========================================================
   商品詳細 → 利用規約チェック → カート → checkout直行
   ＋ 商品詳細：カートを空にするボタン
   ＋ カート：利用規約チェックで checkout ロック（再描画に追従）
   ========================================================= */

// 商品詳細ページ → 利用規約チェック → カート → checkout 直行
document.addEventListener('DOMContentLoaded', function () {
  // 「このあと checkout に自動で行きたい」フラグ（1回だけ有効）
  var FLAG_KEY = 'go_direct_checkout';

  // 商品ページの「レンタルする」「決済へ進む」クリック時の処理（チェックだけして標準処理は通す）
  document.addEventListener(
    'click',
    function (e) {
      const button = e.target.closest(
        '.gpo-clone-atc-button, .gpo-original-atc-button, form[is="product-form"] button[type="submit"], #AddToCart'
      );
      if (!button) return;

      const form = button.closest('form[is="product-form"]');
      if (!form) return;

      const termsCheckbox =
        form.querySelector('#ProductTermsAgree') ||
        form.querySelector('#product-terms-check') ||
        form.querySelector('input[name="attributes[agree_terms]"]') ||
        form.querySelector('input[name="attributes[agree_terms_privacy]"]');

      // チェックがないなら止める（ここだけ自前で止める）
      if (termsCheckbox && !termsCheckbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        alert('利用規約に同意のうえ、お申し込みください。');
        return;
      }

      // チェック済みなら標準の submit を通す（GPO/手数料/オプションのため）
      sessionStorage.setItem(FLAG_KEY, '1');
    },
    true // capture で先にチェックだけする
  );

  // クリックをすり抜けるケース用（Enter送信など）に submit でも止める（※1本だけにする）
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form.matches('form[is="product-form"]')) return;

      const termsCheckbox =
        form.querySelector('#ProductTermsAgree') ||
        form.querySelector('#product-terms-check') ||
        form.querySelector('input[name="attributes[agree_terms]"]') ||
        form.querySelector('input[name="attributes[agree_terms_privacy]"]');

      if (termsCheckbox && !termsCheckbox.checked) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        alert('利用規約に同意のうえ、お申し込みください。');
        return;
      }

      // チェック済みなら標準処理へ
      sessionStorage.setItem(FLAG_KEY, '1');
    },
    true
  );

  // カートページに来たら、必要に応じて checkout に自動遷移
  var path = window.location.pathname.replace(/\/$/, ''); // 末尾の / を削る
  if (path === '/cart' && sessionStorage.getItem(FLAG_KEY) === '1') {
    // 1回きりにする
    sessionStorage.setItem(FLAG_KEY, '0');
    window.location.href = Shopify.routes.root + 'checkout';
  }
});

// 商品詳細ページ：カートを空にするボタン
document.addEventListener('click', function (e) {
  const clearBtn = e.target.closest('.js-product-clear-cart');
  if (!clearBtn) return;

  e.preventDefault();

  if (!window.confirm('カート内の商品をすべて削除します。よろしいですか？')) {
    return;
  }

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
    .then(function () {
      window.location.reload();
    })
    .catch(function (error) {
      console.error(error);
      alert('カートを空にできませんでした。時間をおいて再度お試しください。');
    });
});

/* ============================
   カート：利用規約チェックで checkout ロック（再描画に追従）
   ============================ */
(function () {
  function findCheckoutButton(scope) {
    // テーマ差分対応：button / a の両方を拾う
    return (
      scope.querySelector('button[name="checkout"]') ||
      scope.querySelector('.cart__checkout-button') ||
      scope.querySelector('form[action$="/checkout"] button[type="submit"]') ||
      scope.querySelector('a[href*="/checkout"]')
    );
  }

  function applyCartTermsLock(scope) {
    const termsCheck = scope.querySelector('#terms-check');
    const checkoutBtn = findCheckoutButton(scope);

    if (!termsCheck || !checkoutBtn) return;

    const sync = function () {
      const ok = !!termsCheck.checked;

      // 既存CSSが .js-active 前提なら活かす
      checkoutBtn.classList.toggle('js-active', ok);

      // button の場合は disabled を使う（確実）
      if (checkoutBtn.tagName === 'BUTTON') {
        checkoutBtn.disabled = !ok;
        checkoutBtn.setAttribute('aria-disabled', String(!ok));
      } else {
        // a の場合は click で止めるので aria だけ
        checkoutBtn.setAttribute('aria-disabled', String(!ok));
      }
    };

    // 二重バインド防止
    if (!termsCheck.dataset.bound) {
      termsCheck.addEventListener('change', sync);
      termsCheck.dataset.bound = '1';
    }

    // 未チェックで checkout を踏んだら止める（aタグ対策）
    if (!checkoutBtn.dataset.bound) {
      checkoutBtn.addEventListener(
        'click',
        function (e) {
          if (!termsCheck.checked) {
            e.preventDefault();
            e.stopPropagation();
            alert('利用規約に同意のうえ、お申込みに進んでください。');
          }
        },
        true
      );
      checkoutBtn.dataset.bound = '1';
    }

    // 初期同期
    sync();
  }

  function run() {
    applyCartTermsLock(document);

    // カートドロワーがあるテーマも想定
    document.querySelectorAll('cart-drawer, .drawer').forEach(function (el) {
      applyCartTermsLock(el);
    });
  }

  document.addEventListener('DOMContentLoaded', run);

  // checkout から戻ると DOMContentLoaded が走らないケース対策
  window.addEventListener('pageshow', run);

  // Focal がカートDOMを差し替えるイベントに追従
  document.documentElement.addEventListener('cart:refresh', run);
  document.documentElement.addEventListener('cart:updated', run);
})();
